// #region AnonymousException
const anonymousErrorSymbol = Symbol.for('$$AnonymousError');

export class AnonymousError extends Error {
    cls = anonymousErrorSymbol;
}

export function isAnonymousError(e: any) {
    return e instanceof AnonymousError || (e?.cls === anonymousErrorSymbol);
}
